import { render, staticRenderFns } from "./RatesChart.vue?vue&type=template&id=296d80d6&scoped=true&"
import script from "./RatesChart.vue?vue&type=script&lang=js&"
export * from "./RatesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d80d6",
  null
  
)

export default component.exports